import { NestedFilterAltRounded } from '@modules/queryBuilder/components/NestedFilterAltRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { UUID } from 'v2/core/entities/uuid';

interface QueryFilterActionsProps {
  id: UUID;
  onAddNestedFilter?: () => void;
  onRemoveFilter?: () => void;
  shouldAllowNestedFilter?: boolean;
}

export function QueryFilterActions({
  id,
  onAddNestedFilter: addNestedFilter,
  onRemoveFilter: removeFilter,
  shouldAllowNestedFilter = true,
}: QueryFilterActionsProps) {
  return (
    <Stack
      className={`filter-actions-${id}`}
      direction="row"
      alignItems="center"
    >
      {shouldAllowNestedFilter && (
        <Tooltip title="Add Nested Filter">
          <IconButton onClick={addNestedFilter} size="small">
            <NestedFilterAltRounded color="action" fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
      <IconButton onClick={removeFilter} size="small">
        <CloseRounded color="action" fontSize="inherit" />
      </IconButton>
    </Stack>
  );
}
